import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpEvent, HttpContextToken, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';

export const SHOW_LOADER = new HttpContextToken(() => true);

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private readonly loaderService: LoaderService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    Promise.resolve(null).then(() => {
      if (request.context.get(SHOW_LOADER)) {
        this.loaderService.showLoader();
      }
    });
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      }),

      finalize(() => {
        if (request.context.get(SHOW_LOADER)) {
          this.loaderService.hideLoader();
        }
      })
    );
  }
}
